/** In-memory SSN captured during verify-identity signup; cleared after patient creation or logout. */
let pendingSignupSsn: string | null = null

export function setPendingSignupSsn(ssn: string): void {
    pendingSignupSsn = ssn
}

export function getPendingSignupSsn(): string | undefined {
    return pendingSignupSsn ?? undefined
}

export function clearPendingSignupSsn(): void {
    pendingSignupSsn = null
}
